<template>
    <div class="login-container">
        <div class="login-banner">
            麦克奥迪翔安产业园智慧能碳综合管理平台
        </div>
        <div class="login-form">
            <img
                class="login_form_img"
                src="../../../assets/image/login/circle_bg.png"
                alt
                srcset
            />
            <div class="login-form-inner">
                <div class="login-form-inner-title">
                    <img
                        class="logo-img"
                        src="../../../assets/image/login/logo.png"
                        alt
                        srcset
                    />
                    <!-- <div class="logo">
                        <p style="font-size: 1.3rem; color: #09c3bc">
                            广东颐德港口有限公司
                        </p>
                        <p style="font-size: 1.5rem; color: #56fcff">
                            能源在线监测管理平台
                        </p>
                    </div> -->
                </div>
                <div class="form-scan-wrap">
                    <el-form
                        class="form-wrap-left"
                        :model="loginForm"
                        :rules="rules"
                        ref="loginForm"
                        label-width="0px"
                    >
                        <el-form-item label prop="login_name">
                            <el-input
                                v-model="loginForm.login_name"
                                maxlength="11"
                            >
                                <i
                                    slot="prefix"
                                    class="el-input__icon el-user input_icon"
                                ></i>
                            </el-input>
                        </el-form-item>
                        <el-form-item label prop="login_password">
                            <el-input
                                type="password"
                                v-model="loginForm.login_password"
                                maxlength="20"
                            >
                                <i
                                    slot="prefix"
                                    class="el-input__icon el-pwd input_icon"
                                ></i>
                            </el-input>
                        </el-form-item>
                    </el-form>
                    <!-- <div class="qrcode">
						<img src="../../../assets/image/app/qrcode.png" alt srcset />
						<p style="color: #FFFFFF;font-size: 12px;margin-top: 4px">APP下载</p>
                    </div>-->
                </div>
                <div class="form-bottom">
                    <el-checkbox
                        v-model="checked"
                        @change="rememberAccunt"
                        style="text-color:'#ffffff';"
                        >记住密码</el-checkbox
                    >
                    <!-- <div class="find-pwd" @click="findPwd">找回密码</div> -->
                </div>
                <el-button
                    :disabled="disabled"
                    :class="[
                        'login-btn',
                        { disabled: disabled },
                        {
                            'login-submit-btn':
                                loginForm.login_name && loginForm.login_password
                        }
                    ]"
                    type="primary"
                    @click="handleLogin()"
                    >{{ disabled ? "正在登录..." : "登 录" }}</el-button
                >
            </div>
        </div>
        <reset-pwd :isVisible.sync="isVisible" :showClose="false"></reset-pwd>
        <!-- <div class="login-bottom">
            技术支持：天津远海金风启航新能源有限公司&nbsp;&nbsp;&nbsp;版本号：1.0.5.0919
        </div> -->
    </div>
</template>
<script>
import * as api from "@/http/api.js";
import AES from "crypto-js/aes";
import CryptoJS from "crypto-js";
export default {
    data() {
        return {
            loginForm: {
                login_name: "",
                login_password: ""
            },
            rules: {
                login_name: [
                    {
                        required: true,
                        message: "账号不能为空",
                        trigger: "blur"
                    }
                ],
                login_password: [
                    {
                        required: true,
                        message: "密码不能为空",
                        trigger: "blur"
                    }
                ]
            },
            provinceList: [],
            cityList: [],
            checked: false,
            CRYPTOJSKEY: "abcdefghighkml",
            disabled: false
        };
    },
    created() {
        if (this.$cookie.get("user")) {
            this.decryptAccount();
        }
        sessionStorage.clear();
        document.addEventListener("keydown", this.enterKeyUp);
    },
    methods: {
        enterKeyUp(e) {
            let key = window.event.keyCode || e.keyCode;
            if (key === 13) {
                this.handleLogin();
            }
        },
        /**
         * 路由跳转
         * params { url : 路由路径}
         */
        routerGo(url) {
            this.$router.push(url);
        },
        /**
         * 登录
         */
        handleLogin() {
            this.rememberAccunt();
            this.$refs["loginForm"].validate(valid => {
                if (valid) {
                    this.disabled = true;
                    api.submitLogin(this.loginForm).then(res => {
                        if (res && res.error_code === "0") {
                            sessionStorage.setItem("token", res.token);
                            sessionStorage.setItem("can_logout", "1"); //从用户统计页面登录的用户没有退出按钮
                            this.getUserInfo();
                        }
                        this.disabled = false;
                    });
                    // this.$router.push("/index");
                } else {
                    return false;
                }
            });
        },
        /**
         * 获取用户信息
         */
        getUserInfo() {
            this.$store.dispatch("getUserInfo");
        },
        /**
         * 记住账号--加密
         */
        rememberAccunt() {
            if (this.checked) {
                const username = CryptoJS.AES.encrypt(
                    this.loginForm.login_name,
                    this.CRYPTOJSKEY
                ).toString();
                const password = CryptoJS.AES.encrypt(
                    this.loginForm.login_password,
                    this.CRYPTOJSKEY
                ).toString();
                this.$cookie.set("user", username + "-" + password, 30);
            } else {
                this.$cookie.delete("user");
            }
        },
        /**
         * 记住密码 账号解密
         */
        decryptAccount() {
            const [username, password] = this.$cookie.get("user").split("-");
            const usernameStr = CryptoJS.AES.decrypt(
                username,
                this.CRYPTOJSKEY
            );
            const passwordStr = CryptoJS.AES.decrypt(
                password,
                this.CRYPTOJSKEY
            );
            const usernameOrigin = usernameStr.toString(CryptoJS.enc.Utf8);
            const passwordOrigin = passwordStr.toString(CryptoJS.enc.Utf8);
            this.loginForm.login_name = usernameOrigin;
            this.loginForm.login_password = passwordOrigin;
            this.checked = true;
        }
    },
    destroyed() {
        document.removeEventListener("keydown", this.enterKeyUp);
    }
};
</script>
<style lang="scss">
.login-container {
    width: 100%;
    height: 100%;
    overflow: hidden;
    // display: flex;
    // flex-direction: row;
    // justify-content: center;
    // align-items: center;
    // padding-top: 15%;
    box-sizing: border-box;
    background: url("../../../assets/image/login/login-bg.jpeg") no-repeat;
    background-size: 100% 100%;
    position: relative;

    .login-banner {
        color: #fff;
        position: relative;
        top: 10rem;
        left: 26rem;
        font-size: 1.8rem;
        font-family: cursive;
    }

    .login-form {
        //	width: 405px;
        //	min-width: 350px;
        //	min-height: 330px;
        //	background: #fff;
        //	border: 0.5px solid #00c1de;
        //	border-radius: 10px;
        //	background-size: 100% 100%;
        //	transform: translate(50%, 50%);
        //	background: url('../../../assets/image/login/login_form.png') no-repeat;
        position: absolute;
        top: 24rem;
        right: 14rem;
        transform: translate(0, -50%);

        .login_form_img {
            width: 20rem;
            height: auto;
        }

        .el-input__inner {
            // background-color: #00f9f0;
            color: #333;
            text-indent: 0.5rem;
        }

        .login-form-inner {
            width: 14rem;
            position: absolute;
            right: 50%;
            top: 50%;
            transform: translate(50%, -50%);
            .login-form-inner-title {
                display: flex;
                //  margin-bottom: 0.5rem
            }

            .logo {
                flex: 1;
                margin: 0 auto;
                // margin-bottom: 0.5rem;
                color: #ffffff;
                line-height: 2.5rem;
            }

            .logo-img {
                width: 9rem;
                height: 3rem;
                margin: auto;
            }

            .form-scan-wrap {
                width: 100%;
                display: inline-flex;
                justify-content: space-between;

                .form-wrap-left {
                    //width: calc(100% - 6rem);
                    width: 100%;
                }

                .qrcode {
                    width: 5.3rem;
                    height: 5.3rem;

                    img {
                        width: 80%;
                        height: 80%;
                    }
                }
            }

            .el-checkbox__input.is-checked + .el-checkbox__label {
                //	color: #ffffff;
            }

            .el-form-item {
                margin-bottom: 1.2rem !important;
            }
            .el-input--prefix .el-input__inner {
                padding-left: 40px;
            }

            .el-input {
                width: 100% !important;
            }

            .el-form-item__content {
                line-height: 45px;
            }

            .el-input__icon {
                line-height: 1.3rem !important;
            }

            .el-input__inner {
                height: 2.3rem !important;
                line-height: 2.3rem !important;
                border-radius: 0.8rem;
                background: #00f9f0;
                border: #00f9f0;
                font-size: 1.1rem;
            }

            .el-checkbox__label {
                color: #00f9f0;
                font-size: 0.6rem !important;
            }
            .el-checkbox__inner {
                border: 1px solid #00f9f0;
                background-color: transparent !important;
                width: 0.6rem !important;
                height: 0.6rem !important;
            }
            .input_icon {
                width: 0.9rem;
                margin: 0.65rem 0.6rem;
                display: inline-block;
            }
            .el-user {
                background: url("../../../assets/image/login/user.png")
                    no-repeat;
                background-size: 100% auto;
            }

            .el-pwd {
                background: url("../../../assets/image/login/pwd.png") no-repeat;
                background-size: 100% auto;
            }

            .form-bottom {
                margin-top: -0.5rem;
                width: 225px;
                margin-bottom: 0.5rem;

                .find-pwd {
                    color: #fff;
                    font-size: 14px;
                    padding-top: 4px;
                    cursor: pointer;
                    text-decoration: underline;
                }
            }

            .login-submit-btn {
                background: #035767;
                color: #56fcff;
                &:hover {
                    background: #00c1de;
                    color: #fff;
                }
            }

            .login-btn {
                // color: #fff;
                // color: #00f9f0;
                height: 2.2rem;
                line-height: 2.2rem;
                cursor: pointer;
                // background-color: transparent;
                width: 100%;
                padding: 0;
                border-radius: 0.8rem;
                border: none;
                outline: none;
                margin-top: 0.4rem;
                background: #035767;
                color: #56fcff;
                box-shadow: 0 0 10px 2px #00f9f0;

                // border: 1px solid #00f9f0;
                // box-shadow: 0 0 10px #00f9f0;
                &:hover {
                    background: #00c1de;
                    color: #fff;
                }

                span {
                    font-size: 0.9rem;
                    font-weight: bold;
                }
            }

            .disabled {
                background: #bdbdbd !important;
                color: white !important;
            }

            .form-bottom {
                text-align: left;
                .register-btn,
                .forget-btn {
                    color: #3381ff;
                    font-size: 12px;
                    line-height: 30px;
                    margin: 0 10px;
                    cursor: pointer;
                }

                .register-btn {
                    margin-right: 20px;
                }
            }
        }
    }
    .login-bottom {
        position: absolute;
        bottom: 5px;
        right: 10px;
        font-size: 0.7rem;
        color: #fff;
    }
}

.company-dialog {
    .el-select {
        width: 100%;
    }

    .company-row {
        margin-top: 20px;
    }
}
</style>
